import CitySEOHead from "@/components/feature/CitySEOHead";
import QuincyHeroSection from "./components/HeroSection";
import QuincyStickyNav from "./components/StickyNav";
import QuincyProcessingTimeSection from "./components/ProcessingTimeSection";
import QuincyServicesSection from "./components/ServicesSection";
import QuincyLocalAreaSection from "./components/LocalAreaSection";
import QuincyTestimonialsSection from "./components/TestimonialsSection";
import QuincyAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import QuincyComparisonSection from "./components/ComparisonSection";
import QuincyMistakesSection from "./components/MistakesSection";
import QuincyHowItWorksSection from "./components/HowItWorksSection";
import QuincyFAQSection, { faqs } from "./components/FAQSection";
import QuincyHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import QuincyFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function QuincyPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Quincy"
        state="Florida"
        stateAbbr="FL"
        route="/cities/quincy"
        title="Emergency Passport Quincy, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Quincy, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Gadsden County and North Florida."
        geoPlacename="Quincy, Florida"
        geoPosition="30.5885;-84.5832"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <QuincyHeroSection />
      <QuincyStickyNav />
      <QuincyProcessingTimeSection />
      <QuincyServicesSection />
      <QuincyLocalAreaSection />
      <QuincyTestimonialsSection />
      <QuincyAcceptanceFacilitiesSection />
      <QuincyComparisonSection />
      <QuincyMistakesSection />
      <QuincyHowItWorksSection />
      <QuincyFAQSection />
      <QuincyHelpfulResourcesSection />
      <QuincyFinalCTA />
    </div>
  );
}